export default function (time: string): number {
  return time.split(':')
    .map(item => parseInt(item))
    .reduce((a, b) => a * 60 + b)
}
